module.exports = __webpack_public_path__ + "core-img/fancybox_sprite@2x.aa2aaf3523cb0043716872565a1324ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/gfx/fancybox_sprite@2x.png
// module id = 37
// module chunks = 0